enum ProgramType {
  AmazonStyle = 'AmazonStyle',
  AmazonFresh = 'AmazonFresh',
  Gfc = 'GFC',
  GfcEu = 'GfcEu',
  Go = 'Go',
  WholeFoods = 'WholeFoods',
}

export default ProgramType;
